export default "__VITE_ASSET__C3hTI3LY__"